import React, { FC } from "react";
import ReactLoading from "react-loading";
import colors from "constants/colors";

interface IProps {
  color?: string;
}

const ButtonSpinner: FC<IProps> = ({ color }) => {
  return (
    <div className="button-spinner">
      <ReactLoading type="spin" color={color || colors.white} height={20} width={20} />
    </div>
  );
};

export default ButtonSpinner;
